import React from 'react';
import { PanIcon } from '../icons';
import SidebarTool from './SidebarTool';
import { StageMode } from '../editor';

const ButtonPanTool = () => <SidebarTool tool={StageMode.pan} icon={PanIcon} />;

export default ButtonPanTool;
